module.exports = __webpack_public_path__ + "img/avatar.54e9ec53.png";